import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import StyledMixedCopy from './mixedCopy.style';

const MixedCopy = ({ html, autoLogout = false, ...props }) => {
  useEffect(() => {
    if (autoLogout) {
      // Remove links inside mixed copy if autoLogout is true
      const links = [
        ...document.querySelectorAll('a[target="_blank"]'),
        ...document.querySelectorAll('a[href^="tel:"]'),
        ...document.querySelectorAll('a[href^="mailto:"]')
      ];

      links.forEach(link => {
        link.removeAttribute('href');
        link.classList.add('disabled');
      });
    }
  });

  return <StyledMixedCopy dangerouslySetInnerHTML={{ __html: html }} {...props} />;
};

MixedCopy.propTypes = {
  html: PropTypes.string,
  autoLogout: PropTypes.bool
};

const mapStateToProps = state => ({
  autoLogout: state.token.autoLogout
});

export default connect(mapStateToProps)(MixedCopy);
